import {createSvgIcon} from "@mui/material/utils";

const SurveyCreateLinkIcon = createSvgIcon(
    <path
        d="M280-160v-441q0-33 24-56t57-23h439q33 0 56.5 23.5T880-600v320L680-80H360q-33 0-56.5-23.5T280-160ZM81-710q-6-33 13-59.5t52-32.5l434-77q33-6 59.5 13t32.5 52l10 54h-82l-7-40-433 77 40 226v279q-16-9-27.5-24T158-276L81-710Zm279 110v440h280l160-160v-280H360Zm220 220Zm-40 160h80v-120h120v-80H620v-120h-80v120H420v80h120v120Z"
        transform="matrix(0.025 0 0 0.025 0 24)"
    />,
    "SurveyCreateLinkIcon",
);

export default SurveyCreateLinkIcon;
